import { Alert as MUIAlert, AlertTitle, Typography } from '@mui/material';
import { AnimatePresence, motion } from 'motion/react';
import { CSSProperties } from 'react';

import { useTheme } from './theme';

export type AlertProps = {
  show: boolean;
  title: React.ReactNode;
  description: React.ReactNode;
  wrapperDivStyle?: CSSProperties;
  severity?: React.ComponentPropsWithoutRef<typeof MUIAlert>['severity'];
} & Omit<React.ComponentPropsWithoutRef<typeof MUIAlert>, 'title'>;

const Alert = ({
  show,
  title,
  description,
  wrapperDivStyle,
  severity = 'warning',
  ...rest
}: AlertProps) => {
  const [theme] = useTheme();

  return (
    <AnimatePresence>
      <motion.div
        key={show ? 'open' : 'closed'}
        initial={{
          height: 0,
          filter: 'blur(1px)',
        }}
        animate={{
          height: 'auto',
          opacity: 1,
          filter: 'blur(0px)',
        }}
        exit={{
          height: 0,
          opacity: 0,
          filter: 'blur(1px)',
        }}
        transition={{ type: 'spring', visualDuration: 0.23, bounce: 0 }}
        style={wrapperDivStyle}
      >
        {show && (
          <MUIAlert
            severity={severity}
            {...rest}
            sx={{
              marginTop: 2,
              marginBottom: -1.5,
              ...(theme.palette.mode === 'dark'
                ? { backgroundColor: theme.palette.background.darker }
                : {}),
              ...rest.sx,
            }}
          >
            <AlertTitle sx={{ fontWeight: '700 !important' }}>
              {title}
            </AlertTitle>
            <Typography variant="body1" component="div">
              {description}
            </Typography>
          </MUIAlert>
        )}
      </motion.div>
    </AnimatePresence>
  );
};
export default Alert;
